/**
 * Routes that always render in English / LTR, whatever the member-facing
 * language preference is.
 *
 * The admin panel's copy is written in English and its layout is built for
 * left-to-right, so mirroring it for an Arabic session produces an English
 * interface in a right-to-left shell — worse than either language on its own.
 * The member's stored preference is untouched: leaving /admin restores Arabic.
 */
const LTR_ONLY_PREFIXES = ["/admin"];

export const isLtrOnlyPath = (pathname: string): boolean =>
  LTR_ONLY_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
  );
